import { Subscription } from 'rxjs';

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input,
  OnDestroy, OnInit, Output, ViewEncapsulation
} from '@angular/core';

import { SdMiniPushCardComponent } from '@seb/web-design-system/mini-push-card';

import {
  DeviceService, IExtendedLink, ILinkMedia, ImageRatioEnum,
  PushSizeEnum, SdPushCardComponent, SdThemeComponent
} from '@seb/web-design-system/core';

import { IPushCardBanner } from './push-card-banner.interface';

@Component({
  selector: 'sd-push-card-banner',
  templateUrl: './push-card-banner.component.html',
  styleUrls: ['./push-card-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SdPushCardComponent, SdMiniPushCardComponent]
})
export class SdPushCardBannerComponent extends SdThemeComponent implements OnInit, OnDestroy {
  @Input()
  isLoading = false;

  @Input()
  data: IPushCardBanner;

  @Input()
  isFit = false;

  @Input() class = ''; // override the standard class attr with a new one.

  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.contentClass
    ].filter(Boolean).join(' ');
  }

  @Output()
  clicked = new EventEmitter<IExtendedLink | ILinkMedia>();

  @Output()
  carouselClicked = new EventEmitter<number>();

  contentClass: string;
  imageRatioEnum = ImageRatioEnum;
  pushSizeEnum = PushSizeEnum;
  isMobile$: boolean;
  mobileSubscription: Subscription;

  constructor(
    private readonly deviceService: DeviceService,
    private readonly cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.mobileSubscription?.unsubscribe();
  }

  onClick(event: IExtendedLink | ILinkMedia): void {
    this.clicked.emit(event);
  }

  onCarouselClicked(index?: number) {
    this.carouselClicked.emit(index);
  }
}
